import styled from "styled-components";

export const DropdownOptionWithHoverIconStyled = styled.div<{
  onHover: boolean;
}>``;
